import { SVGProps } from 'react';

export const PlayIconFill = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      width='102'
      height='102'
      viewBox='0 0 102 102'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      {...props}>
      <path
        d='M22.3125 24.0239C22.3125 20.3873 26.2114 18.0819 29.3979 19.8345L78.4454 46.8106C81.7482 48.6271 81.7482 53.3729 78.4454 55.1894L29.3979 82.1655C26.2114 83.9181 22.3125 81.6128 22.3125 77.9761V24.0239Z'
        fill='white'
      />
    </svg>
  );
};
